export const HeaderActionTypes = {
    SWITCH_TO_LOGIN_PAGE: "SWITCH_TO_LOGIN_PAGE",
    SWITCH_TO_REGISTER_PAGE: "SWITCH_TO_REGISTER_PAGE",
    SWITCH_TO_CART_PAGE: "SWITCH_TO_CART_PAGE",
    SWITCH_TO_DASHBOARD_PAGE: "SWITCH_TO_DASHBOARD_PAGE",
    SWITCH_TO_HOME_PAGE: "SWITCH_TO_HOME_PAGE",
};
